/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerProgramAllowedNumberDto } from '../models/EntityModelResponseContainerProgramAllowedNumberDto';
import type { PagedModelEntityModelProgramAllowedNumberDto } from '../models/PagedModelEntityModelProgramAllowedNumberDto';
import type { PagedResourcesAssemblerProgramAllowedNumberDto } from '../models/PagedResourcesAssemblerProgramAllowedNumberDto';
import type { ProgramAllowedNumberDto } from '../models/ProgramAllowedNumberDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramAllowedNumberControllerService {
    /**
     * @returns PagedModelEntityModelProgramAllowedNumberDto OK
     * @throws ApiError
     */
    public static list({
        type,
        assembler,
        page,
        size = 20,
        sort,
    }: {
        type: 'INCOMING' | 'OUTGOING' | 'USSD',
        assembler: PagedResourcesAssemblerProgramAllowedNumberDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelProgramAllowedNumberDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/allowed-numbers',
            query: {
                'type': type,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramAllowedNumberDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: ProgramAllowedNumberDto,
    }): CancelablePromise<EntityModelResponseContainerProgramAllowedNumberDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/allowed-numbers',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        numberId,
    }: {
        numberId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/allowed-numbers/{numberId}',
            path: {
                'numberId': numberId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramAllowedNumberDto OK
     * @throws ApiError
     */
    public static read({
        numberId,
    }: {
        numberId: number,
    }): CancelablePromise<EntityModelResponseContainerProgramAllowedNumberDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/allowed-numbers/{numberId}',
            path: {
                'numberId': numberId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramAllowedNumberDto OK
     * @throws ApiError
     */
    public static update({
        numberId,
        requestBody,
    }: {
        numberId: number,
        requestBody: ProgramAllowedNumberDto,
    }): CancelablePromise<EntityModelResponseContainerProgramAllowedNumberDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/allowed-numbers/{numberId}',
            path: {
                'numberId': numberId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
